/**
 * 意见反馈模块路由
 * 对应菜单：意见反馈
 */

export default [
  // 反馈列表
  {
    path: 'admin/feedback/list',
    name: 'FeedbackList',
    component: () =>
      import(/* webpackChunkName: "feedback-list" */ '@/views/feedback/FeedbackListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'feedback-list',
      title: '意见反馈'
    }
  },
  // 反馈详情 / 处理
  {
    path: 'admin/feedback/detail',
    name: 'FeedbackDetail',
    component: () =>
      import(/* webpackChunkName: "feedback-detail" */ '@/views/feedback/FeedbackDetailView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'feedback-detail',
      title: '反馈详情',
      hidden: true
    }
  }
]
